import { SignUpForViewing16, Tour3d16, Video16 } from '@cian/ui-kit';
import React from 'react';

import { IPhotoFeatureIcons } from '../../../../../../../shared/repositories/search-offers.legacy/v2/types/photoFeatureIcons';
import { FeatureLabel } from '../../../../components/FeatureLabel';
import { FeatureLabels } from '../../../../components/FeatureLabels';
import { useOfferContext } from '../../../../context';

const assetMap: { [index: string]: React.ReactNode } = {
  has3dTour: <Tour3d16 color={'white_100'} />,
  hasFlatTourBooking: <SignUpForViewing16 color={'white_100'} />,
  hasVideo: <Video16 color={'white_100'} />,
};

export function FeatureLabelsContainer() {
  const { offer } = useOfferContext();
  const { photoFeatureIcons } = offer;

  if (!photoFeatureIcons) {
    return null;
  }

  return (
    <FeatureLabels>
      {photoFeatureIcons.map((icon: IPhotoFeatureIcons, index) => {
        return <FeatureLabel key={index} icon={assetMap[icon.type]} title={icon.text} />;
      })}
    </FeatureLabels>
  );
}
